import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLogin from "../Administration/AdminLogin";
import AdminPage from "../Administration/AdminPage";

import TutorialLesson from "../components/Tutorial/TutorialLesson";

import LandingPage from "../landing/LandingPage";
import Login from "../components/Auth/Login";
import Register from "../components/Auth/Register";
import RedefinirSenha from "../components/Auth/RedefinirSenha";

import Dashboard from "../components/Main/Dashboard";

import AssinarPlano from "../asaas/AssinarPlano";
import CheckoutFinalizado from "../asaas/CheckoutFinalizado";

import { useAuth } from "../contexts/AuthContext";
import { useAdminAuth } from "../contexts/AdminAuthContext";

import {
    Box,
    CircularProgress
} from '@mui/material';

export default function AppRoutes() {
    const { adm, loading: adminLoading } = useAdminAuth();
    const { user, loading } = useAuth();

    if (loading || adminLoading) {
        // Exibe um loader simples, pode ser <CircularProgress /> ou similar
        return <Box
            sx={{
                minHeight: "100vh", // ocupa toda a tela vertical
                width: "100vw",     // ocupa toda a tela horizontal (opcional, geralmente só o height basta)
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#fff"     // tela branca
            }}
        >
            <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={50} />
            </Box>
        </Box>;
    }

    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/tutorial" element={user ? <TutorialLesson /> : <Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Register />} />
            <Route path="/redefinir/senha/:token" element={<RedefinirSenha />} />
            <Route path="/planejamento/*" element={user ? <Dashboard /> : <Navigate to="/login" />} />
            <Route path="/checkout/finalizado" element={<CheckoutFinalizado />} />
            <Route path="/assinar" element={<AssinarPlano />} />
            <Route path="/assinar/:plano" element={<AssinarPlano />} />

            <Route path="/administrativo/login" element={<AdminLogin />} />
            <Route
                path="/administrativo/controle"
                element={adm ? <AdminPage /> : <Navigate to="/administrativo/login" />}
            />

            <Route path="*" element={<Navigate to={user ? "/planejamento" : "/login"} />} />
        </Routes>
    );
}
